import React from 'react';

import RichText from '../../../Global/RichText';
import ImageGrid from '../../../Global/Grid';

import styled from 'styled-components';

import {
  TEXT_OUR,
  imagesSources,
} from '../../../../utils/EN/OurVisualPrint/index';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const OurVisualPrint = styled.div`
  padding: 110px 0px;

  @media (max-width: ${breakpoints.mobile}) {
    padding: 20px 0px;
  }
`;

const TextContainer = styled.div`
  text-align: center;
  max-width: 877px;
  width: 100%;
  margin: 0 auto;

  h2 {
    padding: 10px 0;
  }

  p {
    padding: 0 21px;
  }
`;

const OurPrint = () => {
  return (
    <>
      <div className="container">
        <OurVisualPrint>
          <TextContainer>
            <RichText dataText={TEXT_OUR} />
          </TextContainer>
          <ImageGrid images={imagesSources} />
        </OurVisualPrint>
      </div>
    </>
  );
};

export default OurPrint;
